<template>
  <div class="content Tabs">

    <b-tabs card v-model="tabIndex">
      
      <b-tab :title="lang.tab_Details" :title-link-class="textColors" :title-item-class="textColors"
        :active="tabIndex == 0">
        <p v-if="!isAssembly">{{lang.infotext_1}}:</p>
        <LibraryDetailsComponent :lang="lang.LibraryDetails"></LibraryDetailsComponent>



      </b-tab>
      <b-tab :title="lang.tab_History" :title-link-class="textColors" :title-item-class="textColors"
        :active="tabIndex == 1">
        <!-- <p>{{ lang.infotext_1 }}:</p> -->
        <HistoryDetailsComponent :lang="lang.DetailsHistory"></HistoryDetailsComponent>



      </b-tab>
    </b-tabs>

  </div>

</template>
<script>
//import { mapGetters } from 'vuex'

import LibraryDetailsComponent from '@/components/shared/LibraryDetailsComponent'
import HistoryDetailsComponent from '@/components/shared/HistoryDetailsComponent'

export default {
  name: "Content",
  components: {
    LibraryDetailsComponent,
    HistoryDetailsComponent
  },
  props:{
    lang: Object
  },
  data () {
    return {
      tabIndex: 0,

    }
  },
  computed: {
    isAssembly(){
      return false;
    },
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    }

  },
  created() {
    
    this.getTabIndex();

  },
  
  watch: {
    tabIndex: function (newVal) {

      let obj = {};
      obj[this.$route.path + "__middle"] = newVal;

      this.$store.commit("SETTABDATA", obj);

      //####################
    }
  },
  methods: {
    getTabIndex() {
      

      if (this.$store.getters.tabData[this.$route.path + "__middle"] != undefined) {
        this.tabIndex = this.$store.getters.tabData[this.$route.path + "__middle"];
      } else {
        this.tabIndex = 0;
      }

    },
  },
}
</script>

<style scooped>

  .bv-example-row-max{
    max-width: 100%;
    padding-right: 0px;
    padding-left: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/LibraryManager/Views/LibraryDetails/Middle/Content/Content.vue